import React, { ReactNode } from 'react';

import { CheckoutContextType } from '../types';

export const CheckoutContext =
  React.createContext<CheckoutContextType | undefined>(undefined);

export const CheckoutProvider = ({
  value,
  children,
}: {
  children: ReactNode;
  value: CheckoutContextType;
}) => (
  <CheckoutContext.Provider value={value}>{children}</CheckoutContext.Provider>
);

export const useCheckoutContext = () => {
  const context = React.useContext(CheckoutContext);

  if (context === undefined) {
    throw new Error(
      'useCheckoutContext must be used within a CheckoutProvider',
    );
  }

  return context;
};
